import * as React from "react";
import { Card } from "@grandvisionhq/common";
import { useIntl } from "@grandvisionhq/state";
/* empty css                  */
const StoreSummary = ({
  name,
  streetName,
  streetNumber,
  actions,
  className,
  title,
  errorNotification = null
}) => {
  const { getLabel } = useIntl();
  return /* @__PURE__ */ React.createElement(Card, { "data-t": "service-store-summary", className }, /* @__PURE__ */ React.createElement(Card.Content, null, actions?.onEdit && /* @__PURE__ */ React.createElement(Card.Actions, null, /* @__PURE__ */ React.createElement(
    Card.Button,
    {
      onClick: actions.onEdit,
      children: getLabel("common.actions.edit"),
      "data-t": "store-edit-action"
    }
  )), /* @__PURE__ */ React.createElement(Card.Heading, { variant: "subheading2" }, title ?? getLabel("checkout.serviceStore.title")), errorNotification, /* @__PURE__ */ React.createElement(Card.Text, { color: "text-secondary", variant: "caption" }, name), /* @__PURE__ */ React.createElement(Card.Text, { color: "text-secondary", variant: "caption" }, streetName, " ", streetNumber)));
};
export {
  StoreSummary
};
//# sourceMappingURL=StoreSummary.js.map
